export default __webpack_public_path__ + "e15bca75e1f42e3706330d0e683c8755.png";